import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 19 19"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8.08 11.646 5.759 9.323a.73.73 0 0 0-.522-.213.7.7 0 0 0-.532.213.72.72 0 0 0-.217.527q0 .31.217.527l2.744 2.744q.27.27.633.271.36 0 .633-.27l5.563-5.564a.73.73 0 0 0 .213-.522.7.7 0 0 0-.213-.532.72.72 0 0 0-.527-.217.72.72 0 0 0-.527.217zM9.503 19q-1.972 0-3.706-.748a9.6 9.6 0 0 1-3.016-2.03 9.6 9.6 0 0 1-2.032-3.016A9.25 9.25 0 0 1 0 9.502Q0 7.53.748 5.796a9.6 9.6 0 0 1 2.03-3.016A9.6 9.6 0 0 1 5.794.748 9.25 9.25 0 0 1 9.498 0q1.972 0 3.706.748a9.6 9.6 0 0 1 3.017 2.03 9.6 9.6 0 0 1 2.03 3.016A9.25 9.25 0 0 1 19 9.498q0 1.972-.748 3.706a9.6 9.6 0 0 1-2.03 3.017 9.6 9.6 0 0 1-3.016 2.03A9.25 9.25 0 0 1 9.502 19"
    }, null, -1)
  ]))]))
}
export default { render: render }